import React, { createContext, useState, useEffect, useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  setProfileData,
  setTransactions,
  setSettings,
} from "../Redux/Actions/TechAppAction";
import useHttp from "../hooks/useHttp";
import lang from "../Constant/lang.json";

export const techappContext = createContext();
export const TechappProvider = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { TicketHttpService, HttpService } = useHttp();
  const [generatedReceipt, setGeneratedReceipt] = useState("");
  const [orders, setOrders] = useState({
    available: [],
    special: [],
    doing: [],
    reject: [],
    done: [],
  });
  const [resendCodeLoading, setResendCodeLoading] = useState(false);
  const [sliderData, setSliderData] = useState([]);
  const [sendCommentLoading, setSendCommentLoading] = useState(false);
  const [appInfoData, setAppInfoData] = useState(null);
  const [servicesPartsData, setServicesPartsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [transactionsPaginateLoading, setTransactionPaginateLoading] =
    useState(false);
  const [finalFactor, setFinalFactor] = useState(false);
  const [subTagBtn, setSubTagBtn] = useState(null);
  const [defCostModal, setDefCostModal] = useState(false);
  const [totalOrders, setTotalOrders] = useState(null);
  const [getBadges, setGetBadges] = useState(null);
  const [tickets, setTickets] = useState(null);
  const [announcements, setAnnouncements] = useState({
    privates: [],
    publics: [],
    trainings: [],
  });
  const [comments, setComments] = useState(null);
  const [createTicketOrderId, setCreateTicketOrderId] = useState("");
  const [catsItem, setCatsItem] = useState(null);
  const [ports, setPorts] = useState(null);
  const [reciveBtn, setReciveBtn] = useState(1);
  const [searchResult, setSearchResult] = useState([]);
  const [paginateLoading, setPaginateLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const order = useSelector((state) => state.TechAppReducer.orderObj);
  const ticket = useSelector((state) => state.TechAppReducer.ticketObj);
  const platform = useSelector((state) => state.AuthReducer.platform);
  const transactionsData = useSelector(
    (state) => state.TechAppReducer.transactionsData
  );

  const isFetchingRef = useRef(false);

  useEffect(() => {
    if (location.pathname === "/techapp/tickets") {
      setCreateTicketOrderId("");
    }
  }, [location.pathname]);

  // ---------------------------------------------------orders-----------------------------------------------------------
  // get orders
  const getOrder = async (type) => {
    let postData;
    switch (type) {
      // available order params
      case "available":
        postData = {
          notified: "1",
          include: "service,address.location,user,details",
          doing_count: "1",
          done_count: "1",
          complainted_count: "1",
          promotion_count: "1",
        };
        break;
      // special order params
      case "special":
        postData = {
          notified: "1",
          include: "service,address.location,user,details",
          doing_count: "1",
          done_count: "1",
          complainted_count: "1",
          status: "16",
          promotionbox: "1",
        };
        break;
      // doing order params
      case "doing":
        postData = {
          include: "service,address.location,user,details,items",
          status: "4,9",
        };
        break;
      // reject order params
      case "reject":
        postData = {
          include: "service,address.location,user,details,items",
          status: "7",
        };
        break;
      // done order params
      case "done":
        postData = {
          include: "service,address.location,user,details,items",
          status: "1",
        };
        break;
      default:
        break;
    }
    try {
      setLoading(true);
      const response = await HttpService.post("/api/v1.0/orders", postData);
      switch (type) {
        // available order params
        case "available":
          setOrders({ ...orders, available: response.data.data });
          break;
        // special order params
        case "special":
          setOrders({ ...orders, special: response.data.data });
          break;
        // doing order params
        case "doing":
          setOrders({ ...orders, doing: response.data.data });
          break;
        // reject order params
        case "reject":
          setOrders({ ...orders, reject: response.data.data });
          break;
        // done order params
        case "done":
          setOrders({ ...orders, done: response.data.data });
          break;
        default:
          break;
      }
      setLoading(false);
    } catch ({ err, response }) {
      setLoading(false);
    }
  };

  // ---------------------------------------------------actions-----------------------------------------------------------
  // send action request------------------------------------------------------------
  const sendAction = async (action_id, postItems) => {
    let postData;
    switch (action_id) {
      // digital receipt
      case 21:
        postData = {
          order_id: order.id,
          action: action_id,
          desc: generatedReceipt,
        };
        break;
      // cancel order
      case 5:
        postData = postItems;
        break;
      // accept promotionbox order
      case 6:
        postData = {
          order_id: order.id,
          action: action_id,
          submit_code: 1,
        };
        break;
      // reject order
      case 7:
        postData = postItems;
        break;
      default:
        break;
    }
    try {
      setLoading(true);
      const response = await HttpService.post(
        "/api/v1.0/order/action",
        postData
      );
      toast.success(response?.data?.responseJSON?.message);
      navigate("/techapp");
      setFinalFactor(false);
      setLoading(false);
    } catch ({ err, response }) {
      setLoading(false);
      toast.error(response?.data?.errors[0]?.detail);
    }
  };

  // fee declaration action request------------------------------------------------------
  const feeDeclarationHandler = async (
    index,
    spendItems,
    totalEarned,
    profit,
    description,
    isLabel,
    fileList,
    warrantyDesc
  ) => {
    let newItems = [];
    const data = new FormData();
    fileList?.forEach((file) => {
      data.append("media[]", file);
    });
    spendItems
      .filter(
        (item) => item?.amount?.length !== 0 && parseFloat(item?.amount) > 0
      )
      .forEach((x) => {
        for (var i = 0; i < x.count; i++) {
          newItems.push({
            price: x.amount,
            item: x.title,
            count: x.count,
            sum: parseFloat(x.amount * x.count),
          });
        }
      });
    for (var i = 0; i < newItems.length; i++) {
      data.append(`items[${i}][price]`, newItems[i].price);
      data.append(`items[${i}][item]`, newItems[i].item);
      data.append(`items[${i}][count]`, newItems[i].count);
      data.append(`items[${i}][sum]`, newItems[i].sum);
    }
    switch (index) {
      case 8:
        data.append("order_id", order.id);
        data.append("action", index);
        data.append("submit_data", 1);
        data.append("desc", description);
        data.append("with_cost", 1);
        data.append("total_cost", parseFloat(totalEarned));
        data.append("net_profit", parseFloat(profit));
        data.append("subscription_label", isLabel);
        data.append("warranty_receipt", warrantyDesc);
        break;
      case 11:
        data.append("order_id", order.id);
        data.append("action", index);
        data.append("submit_data", 1);
        data.append("desc", description);
        data.append("with_cost", 1);
        data.append("total_cost", parseFloat(totalEarned));
        data.append("net_profit", parseFloat(profit));
        data.append("subscription_label", isLabel);
        data.append("warranty_receipt", warrantyDesc);
        break;
      default:
        break;
    }
    try {
      setLoading(true);
      const response = await HttpService.post("/api/v1.1/order/action", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          "app-type": "7",
        },
      });
      setLoading(false);
      if (response.data.code_sent) {
        setDefCostModal(true);
        toast.success(response?.data?.message);
      }
    } catch ({ err, response }) {
      setLoading(false);
    }
  };

  // fee declaration action request------------------------------------------------------
  const feeDeclarationResendCode = async (index) => {
    let postData = new FormData();
    postData.append("action", index);
    postData.append("order_id", order.id);
    postData.append("resend_code", 1);
    try {
      setResendCodeLoading(true);
      const response = await HttpService.post(
        "/api/v1.1/order/action",
        postData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "app-type": "7",
          },
        }
      );
      setResendCodeLoading(false);
      if (response.status === 200) {
        toast.success(response?.data?.message);
      }
    } catch ({ err, response }) {
      setResendCodeLoading(false);
    }
  };

  // fee declaration complaint
  const fixComplaintHandler = async (complaintDescription, files) => {
    let postData = new FormData();
    postData.append("order_id", order.id);
    postData.append("action", 11);
    postData.append("submit_data", 1);
    postData.append("desc", complaintDescription);
    postData.append("with_cost", 0);
    await files?.forEach((file) => {
      postData.append("media[]", file);
    });
    try {
      setLoading(true);
      const response = await HttpService.post(
        "/api/v1.1/order/action",
        postData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setLoading(false);
      if (response.data.code_sent) {
        setDefCostModal(true);
        toast.success(lang.CONFIRM_CODE_SENT_SUCCESSFULLY);
      }
    } catch ({ err, response }) {
      setLoading(false);
    }
  };

  // define cost submit request------------------------------------------------------
  const submitUserCode = async (index, value) => {
    let postData;
    postData = {
      order_id: order.id,
      action: index,
      submit_code: 1,
      code: value,
    };
    try {
      setLoading(true);
      const response = await HttpService.post(
        "/api/v1.1/order/action",
        postData
      );
      setLoading(false);
      if (response.data.status === true) {
        navigate("/techapp/");
        toast.success(lang.ORDER_FEE_DECLARATE_SUCCESSFULLY);
        setDefCostModal(false);
      }

      if (response.data.success !== undefined && response.data.success === false) {
        toast.warning(response.data.message);
      }
    } catch ({ err, response }) {
      setLoading(false);
    }
  };

  // ---------------------------------------------------tickets-----------------------------------------------------------
  //get badges-------------------------------------------------------------------
  const getBadgesReq = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        process.env.REACT_APP_TICKET_BASE_URL + "/api/v1/badges",
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      setGetBadges(response.data.data);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error(lang.USER_NOT_FOUND);
        handleLogout();
      } else if (err.response && err.response.status === 422) {
        err.response.data.errors.forEach((err) => {
          toast.warning(err.detail);
        });
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
    }
  };

  // getMessages-----------------------------------------------------------------
  const getMessages = async (type, page) => {
    try {
      if (page === 1) {
        setLoading(true);
      } else {
        setPaginateLoading(true);
      }
      const response = await TicketHttpService.get(
        `/api/v1/announcements?page=${page}&type=${type}`
      );
      switch (type) {
        case "private":
          if (page === 1) {
            setAnnouncements({
              ...announcements,
              privates: response.data.data,
            });
          } else {
            response.data.data.forEach((pr) => {
              announcements.privates.push(pr);
            });
          }
          break;
        case "public":
          if (page === 1) {
            setAnnouncements({
              ...announcements,
              publics: response.data.data,
            });
          } else {
            response.data.data.forEach((pub) => {
              announcements.publics.push(pub);
            });
          }
          break;
        case "training":
          if (page === 1) {
            setAnnouncements({
              ...announcements,
              trainings: response.data.data,
            });
          } else {
            response.data.data.forEach((tr) => {
              announcements.trainings.push(tr);
            });
          }
          break;
        default:
          break;
      }
      setTotalPage(response?.data?.meta?.last_page);
      if (page === 1) {
        setLoading(false);
      } else {
        setPaginateLoading(false);
      }
    } catch ({ err, response }) {
      if (page === 1) {
        setLoading(false);
      } else {
        setPaginateLoading(false);
      }
    }
  };

  //get tickets-------------------------------------------------------------------
  const getTickets = async (page) => {
    try {
      if (page === 1) {
        setLoading(true);
      } else {
        setPaginateLoading(true);
      }
      const response = await TicketHttpService.get(
        `/api/v1/tickets?page=${page}`
      );
      setTotalPage(response?.data?.meta?.last_page);
      if (page === 1) {
        setTickets(response.data.data);
      } else {
        response.data.data.forEach((tk) => {
          tickets.push(tk);
        });
      }
      getBadgesReq();
      if (page === 1) {
        setLoading(false);
      } else {
        setPaginateLoading(false);
      }
    } catch ({ err, response }) {
      if (page === 1) {
        setLoading(false);
      } else {
        setPaginateLoading(false);
      }
    }
  };

  // get Tickets Comment---------------------------------------------------------
  const ticketComments = async (index) => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_TICKET_BASE_URL + `/api/v1/tickets/${index}`,
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      setComments(response.data.data.comments);
      setLoading(false);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error(lang.USER_NOT_FOUND);
        setLoading(false);
        handleLogout();
      } else if (err.response && err.response.status === 422) {
        err.response.data.errors.forEach((err) => {
          toast.warning(err.detail);
          setLoading(false);
        });
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
      setLoading(false);
    }
  };

  // post ticket comment---------------------------------------------------------
  const sendComment = async (text, fileList, voices) => {
    const token = localStorage.getItem("token");
    const data = new FormData();
    fileList.forEach((file) => {
      data.append("file[]", file);
    });
    voices.forEach((voice) => {
      data.append("file[]", voice.file);
    });
    if (voices.length > 0 && text.length === 0) {
      data.append("comment", lang.RECORDED_VOICE);
    } else {
      data.append("comment", text);
    }
    data.append("app", platform);
    try {
      setSendCommentLoading(true);
      await axios.post(
        process.env.REACT_APP_TICKET_BASE_URL +
          `/api/v1/tickets/${ticket.id}/comments`,
        data,
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      ticketComments(ticket.id);
      setSendCommentLoading(false);
    } catch (err) {
      setSendCommentLoading(false);
      if (err.response && err.response.status === 401) {
        toast.error(lang.USER_NOT_FOUND);
        handleLogout();
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
    }
  };

  // get ticket categories------------------------------------------------------
  const ticketCat = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        process.env.REACT_APP_TICKET_BASE_URL + "/api/v1/tickets/categories",
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      setCatsItem(response.data.data);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error(lang.USER_NOT_FOUND);
        handleLogout();
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
    }
  };

  // post ticket--------------------------------------------------------------------
  const postTicketReq = async (
    firstTitle,
    secondTitle,
    des,
    catId,
    fileList,
    voices
  ) => {
    const data = new FormData();
    const token = localStorage.getItem("token");
    let finalTitle;
    if (secondTitle !== null) {
      finalTitle = secondTitle;
    } else if (secondTitle === null) {
      finalTitle = firstTitle;
    }
    fileList.forEach((file) => {
      data.append("file[]", file);
    });
    voices.forEach((voice) => {
      data.append("file[]", voice.file);
    });
    data.append("title", finalTitle);
    data.append("message", des);
    data.append("category", catId);
    data.append("order_number", createTicketOrderId);
    data.append("app", platform);
    try {
      setLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_TICKET_BASE_URL + "/api/v1/tickets",
        data,
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      setLoading(false);
      if (response.data.meta.code === 200) {
        navigate("/techapp/tickets");
        toast.success(lang.SUBMITED_SUCCESSFULLY);
      }
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.status === 401) {
        toast.error(lang.USER_NOT_FOUND);
        handleLogout();
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
    }
  };

  // seen ticket--------------------------------------------------------------------
  const seenTicket = async (index) => {
    const token = localStorage.getItem("token");
    try {
      await axios.post(
        process.env.REACT_APP_TICKET_BASE_URL + "/api/v1/badges",
        {
          announcement: [],
          comment: [],
          ticket: [index],
          app: platform,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      getBadgesReq();
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.status === 401) {
        toast.error(lang.USER_NOT_FOUND);
        handleLogout();
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
    }
  };

  // seen announcement--------------------------------------------------------------------
  const seenAnnouncement = async (index) => {
    const token = localStorage.getItem("token");
    try {
      await axios.post(
        process.env.REACT_APP_TICKET_BASE_URL + "/api/v1/badges",
        {
          announcement: [index],
          comment: [],
          ticket: [],
          app: platform,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      getBadgesReq();
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.status === 401) {
        toast.error(lang.USER_NOT_FOUND);
        handleLogout();
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
    }
  };

  // ---------------------------------------------------other requests-----------------------------------------------------------
  // get Ports-----------------------------------------------------------------------
  const getPorts = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + "/api/v1.0/ports",
        {
          headers: {
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      setPorts(response.data.ports);
    } catch (err) {
      toast.error(lang.API_500_ERROR_MESSAGE);
    }
  };

  // init payment-----------------------------------------------------------------------
  const initPaymentReq = async (inAmount, inPort) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + "/api/v1.0/init_payment",
        {
          amount: inAmount,
          port: inPort,
          desc: "Payment from technician PWA web app",
        },
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      if (response.data.status === true) {
        window.location.replace(
          process.env.REACT_APP_BASE_URL +
            `/api/v1.0/pay/${response.data.authority}?port=${inPort}`
        );
      }
    } catch ({ err, response }) {
      if (response?.status === 401) {
        toast.error(lang.USER_NOT_FOUND);
        handleLogout();
      } else if (response?.status === 403) {
        toast.error(response?.data?.message);
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
    }
  };

  // Profile-------------------------------------------------------------------------
  const profile = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + "/api/v1.0/profile",
        {
          include: "services,supportings",
        },
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      dispatch(setProfileData(response.data.data));
      setLoading(false);
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.status === 401) {
        toast.error(lang.USER_NOT_FOUND);
        handleLogout();
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
    }
  };

  // note---------------------------------------------------------------------------
  const addNote = async (orderId, note) => {
    if (note.length < 6) {
      toast.warning(lang.NOTE_MUST_BE_6_CHARACTAR_AT_LEAST);
    } else {
      try {
        setLoading(true);
        const response = await HttpService.post(
          `/api/v1.1/orders/${orderId}/note`,
          {
            note,
          }
        );
        setLoading(false);
        toast.success(response?.data?.message);
        navigate("/techapp");
      } catch ({ err, response }) {
        setLoading(false);
      }
    }
  };

  // transactions-------------------------------------------------------------------
  const transactions = async (page = 1, per_page = 10, append = false) => {
    try {
      if (page === 1) {
        setLoading(true);
      } else {
        setTransactionPaginateLoading(true);
      }

      const response = await axios.post(
        process.env.REACT_APP_BASE_URL +
          "/api/v1.0/transactions?page=" +
          page +
          "&per_page=" +
          per_page,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );

      if (append) {
        dispatch(setTransactions([...transactionsData, ...response.data.data]));
      } else {
        dispatch(setTransactions(response.data.data));
      }

      setHasMore(
        response.data.meta.current_page < response.data.meta.last_page
      );
      setLoading(false);
      setTransactionPaginateLoading(false);
      isFetchingRef.current = false; // 🔓 UNLOCK
    } catch (err) {
      if (err.response && err.response.status === 401) {
        handleLogout();
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
      setLoading(false);
      setTransactionPaginateLoading(false);
      isFetchingRef.current = false; // 🔓 UNLOCK
    }
  };

  // app info--------------------------------------------------------------------
  const appInfo = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + "/api/v1.0/app_info?type=3",
        {
          headers: {
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      setAppInfoData(response.data);
    } catch (err) {
      toast.error(lang.API_500_ERROR_MESSAGE);
    }
  };

  // services parts--------------------------------------------------------------
  const servicesParts = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL +
          `/api/v1.0/services/${order.service.data.id}/items`,
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      setServicesPartsData(response.data);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error(lang.USER_NOT_FOUND);
        handleLogout();
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
    }
  };

  // call log--------------------------------------------------------------------
  const callLogReq = async (phone, order_id) => {
    let d = new Date();
    try {
      await HttpService.post("/api/v1.1/call_log", {
        phone: phone,
        order_id: order_id.toString(),
        duration: "0",
        called_at: d,
      });

      window.location.href = `tel:${phone}`;
    } catch ({ err, response }) {
      setLoading(false);
      toast.error(lang.API_500_ERROR_MESSAGE);
    }
  };

  // available-------------------------------------------------------------------
  const available = async (index, note) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.put(
        process.env.REACT_APP_BASE_URL + "/api/v1.0/available",
        {
          available: index,
          desc: note,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      toast.success(response.data.message);
      profile();
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error(lang.USER_NOT_FOUND);
        handleLogout();
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
    }
  };

  // searchOrder-------------------------------------------------------------------
  const searchOrder = async (index) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + "/api/v1.0/orders/search",
        {
          status: 1,
          pattern: index,
          include: "service,address.location,user,details,items",
          limit: 7,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      if (response.data.data.length === 0) {
        setSearchResult(null);
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error(lang.USER_NOT_FOUND);
        handleLogout();
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
    }
  };

  // logout-------------------------------------------------------------------
  const handleLogout = async () => {
    try {
      HttpService.post("/api/v1.0/logout");
      localStorage.removeItem("token");
      localStorage.removeItem("auth_from_admin");
      window.location.replace("/");
      toast.error(lang.YOU_ARE_LOGGED_OUT);
    } catch ({ err, response }) {}
  };

  // slider images ---------------------------------------------------------------
  const getSliderImages = async () => {
    try {
      const response = await HttpService.get("/api/v1.0/sliders");
      setSliderData(response.data.data);
    } catch ({ err, response }) {
      toast.error(lang.API_500_ERROR_MESSAGE);
    }
  };

  // generate reciept ---------------------------------------------------------------
  const generateTextReciept = async (postData) => {
    const data = new FormData();
    Object.keys(postData).forEach((key) => {
      if (key === "file") {
        (postData.file || []).forEach((file) => {
          data.append("file[]", file);
        });
      } else if (postData[key] !== undefined && postData[key] !== null) {
        data.append(key, postData[key]);
      }
    });
    try {
      setLoading(true);
      const response = await HttpService.post(
        "/api/v1.1/receipt/create",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setGeneratedReceipt(response.data.message);
      setFinalFactor(true);
      setLoading(false);
    } catch ({ err, response }) {
      setLoading(false);
      toast.error(lang.REQUIRED_FIELDS_AND_IMAGE);
    }
  };

  // app settings ---------------------------------------------------------------
  const [settingsLoaded, setSettingsLoaded] = useState(false);

  const getSettings = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + "/api/v1.0/app_settings",
        {
          headers: {
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      const settingsObj = {};
      response.data.data.forEach((item) => {
        settingsObj[item.name] = item.value;
      });
      dispatch(setSettings(settingsObj));
    } catch (err) {
      toast.error(lang.API_500_ERROR_MESSAGE);
    } finally {
      setSettingsLoaded(true);
    }
  };

  const value = {
    orders,
    loading,
    transactions,
    profile,
    handleLogout,
    available,
    getOrder,
    addNote,
    appInfo,
    appInfoData,
    servicesParts,
    servicesPartsData,
    sendAction,
    finalFactor,
    setFinalFactor,
    subTagBtn,
    setSubTagBtn,
    feeDeclarationHandler,
    defCostModal,
    setDefCostModal,
    totalOrders,
    setTotalOrders,
    getBadgesReq,
    getBadges,
    getTickets,
    tickets,
    getMessages,
    announcements,
    ticketComments,
    comments,
    sendComment,
    ticketCat,
    catsItem,
    setCatsItem,
    postTicketReq,
    submitUserCode,
    getPorts,
    ports,
    initPaymentReq,
    reciveBtn,
    setReciveBtn,
    callLogReq,
    fixComplaintHandler,
    searchOrder,
    searchResult,
    seenTicket,
    paginateLoading,
    setPaginateLoading,
    totalPage,
    setTotalPage,
    sendCommentLoading,
    createTicketOrderId,
    setCreateTicketOrderId,
    sliderData,
    setSliderData,
    getSliderImages,
    generateTextReciept,
    generatedReceipt,
    setGeneratedReceipt,
    seenAnnouncement,
    feeDeclarationResendCode,
    resendCodeLoading,
    page,
    setPage,
    hasMore,
    transactionsPaginateLoading,
    isFetchingRef,
    settingsLoaded,
    getSettings,
  };
  return (
    <techappContext.Provider value={value}>
      {props.children}
    </techappContext.Provider>
  );
};